// Consistent page header: title, optional subtitle, and an actions slot
// (buttons, filters). Theme-aware in light & dark.

import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const PageHeader = ({ title, subtitle, action }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: { xs: "flex-start", sm: "center" },
      justifyContent: "space-between",
      flexDirection: { xs: "column", sm: "row" },
      gap: 1.5,
      mb: 3,
    }}
  >
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {action && <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>{action}</Box>}
  </Box>
);

export default PageHeader;
